import { Injectable } from '@angular/core';

@Injectable()
export class Config {
  static readonly AVATAR_FUNCTIONALITY: boolean = true;
  static readonly USE_HARDCODED_FIRST_VIDEO: boolean = true;
  static readonly HARDCODED_FIRST_VIDEO_URL: string = "https://d-id-talks-prod.s3.us-west-2.amazonaws.com/auth0%7C6526cea217d420d9d9fce62b/tlk_yB91EF5chTT9zIIfmfxrE/1698180828985.mp4?AWSAccessKeyId=AKIA5CUMPJBIK65W6FGA&Expires=1698267235&Signature=rIDQC2M%2BudG2xAOC3XrQ%2F2kK6dQ%3D&X-Amzn-Trace-Id=Root%3D1-65382ee3-4f94bd531521d4e85755ec55%3BParent%3D8bd32872e62fd829%3BSampled%3D1%3BLineage%3D6b931dd4%3A0";
  static readonly CONNECTING_STATUS: string = 'connecting';
  static readonly CONNECTED_STATUS: string = 'connected';
  static readonly STREAMING_STATUS: string = ''; // removing "streaming" message
  static readonly STREAMING_FAILED: string = 'streaming failed';
  static readonly EXTERNAL_RESOLUTION_REQUEST_MESSAGE: string = 'I was unable to identify your issue';
  static readonly EXTERNAL_RESOLUTION: string = 'external_resolution';
  static readonly FIND_EXTERNAL: string = 'find_external';
  static readonly STARTED: string = 'started';
  static readonly FAILED: string = 'failed';
  static readonly CLOSED: string = 'closed';
  static readonly CONNECTION_FAILED: string = 'connection failed';
  static readonly BOT_MESSAGE: string = 'Hello, I am MeteredGPT.';
  static readonly LEYA: string = 'meteredgpt';
  static readonly USER: string = 'user';
  static readonly BOT: string = 'bot';
  static readonly ALERT: string = 'alert';
  static readonly SYSTEM: string = 'system';
  static readonly MOLSON: string = 'Molson Coors';
  static readonly REQUIRED: string = '* Required fields.';
  static readonly RESET_MESSAGE: string = '<div><p class="red-text">All chat history will be lost.</p></br>Select Confirm to proceed.</div>';
  static readonly BOT_RESPONSE: string = 'We are experiencing issues with our backend, please try again later.';
  static readonly UNSAVED_CHANGES_MESSAGE: string = 'Your unsaved changes will be lost, click confirm to proceed.';
}
